import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: false
})
export class UnAuthorizedComponent implements OnInit {
  message = 'You are not authorized to access the application.';
  constructor(public translateService: TranslateService,) { };

  ngOnInit(): void {

    setInterval(()=>{
      this.message = this.translateService.instant("msg.unauth_nav.text");
    },1000)
  }


}